import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from 'src/app/shared/models/listing.model';
import { Languages, Service } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { ReportsService } from 'src/app/shared/services/reports.service';
import { Router, NavigationExtras } from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/front-user/shared/models/user.model';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { MenuItem } from '../../agent-registration-request/offline-agent-list/offline-agent-list.component';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { MyTasksService } from 'src/app/shared/services/my-Tasks.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';




@Component({
  selector: 'app-incomplete-tasks',
  templateUrl: './incomplete-tasks.component.html'
})
export class IncompleteTasksComponent implements OnInit {
  private collection: Listing;
  private itemsMenu: MenuItem[] = [];
  lang: string;
  pageSize = 15;
  isErrorMessage: Boolean = false;
  agentNameNotFoundMessage: string;
  transitRequestId: string;
  directionId: string = "";
  transitDateFormatted: string = "";
  transitDate: string = "";
  public sailDirections: SailDirection[] = [];
  feesRequestId: string;
  HasMenu: boolean = true;
  public currentUser: User = new User();
  @ViewChild('EBookingReport', { static: false }) gridView: GridViewComponent;
  isAdmin: boolean;
  responseObj: ResponseObject;

  constructor(private baseRequestSrv: BaseRequestService,
    private myReportsService: ReportsService,
    private global: GlobalServices,
     private lookupService: LookupService,
    private agentService: AgentService,
    private myTasksService: MyTasksService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private localeService: BsLocaleService,
    public datepipe: DatePipe,
  ) {
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
  }

  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;

  async ngOnInit(): Promise<void> {
    {
      this.loadSailDirections();
      this.loadSearchCriteria();
      this.loadEBookingReport() ;
      this.currentUser = this.authenticationService.currentUserValue;
      // this.currentUser = this.global.user;
      defineLocale('custom locale', enGbLocale);
      this.localeService.use('custom locale');
      if (this.currentUser.IsAdmin) {
        this.isAdmin = true;
      }
      this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    }
    this.agentNameNotFoundMessage = this.translate.instant('SHARED.NoItems');

  }


  loadEBookingReport() {
     this.global.isLoaderEnabled = true;
    this.storeSearchCriteria();
    this.transitDate = this.transitDate == null ? "" : this.transitDate;
    this.transitDateFormatted = this.transitDate == "" ? "" : this.datepipe.transform(this.transitDate, 'MM/dd/yyyy');
    this.myReportsService.getIncompleteTasks(0, this.pageSize, null,null,this.directionId,this.transitDateFormatted).subscribe(
        s => {
          this.responseObj = s;
          if (!this.responseObj.Success) {
            this.isErrorMessage = true;
          }
          else {
            this.collection = s.Data;
          }
        },
        () => console.log("Something went wrong!!"),
        () => this.loadCollectionCompleted(),

      );
    }
    loadCollectionCompleted() {
    this.loadItemsMenu();

    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      "Report/getIncompleteTasks?pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
      "&sortBy=" + "&sortDir=" +
      "&language=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En") +
      "&directionId=" + this.directionId +
      "&transitDate=" + this.transitDateFormatted ,
      "SHARED.REPORTS.InCompelete_OBJECT", this.itemsMenu, "", "", "");
    this.global.isLoaderEnabled = false;

  }
 loadSearchCriteria() {
    if (this.global.eBookingReportSearchCriteria.length > 0) {
      this.transitDate = this.global.eBookingReportSearchCriteria[0].transitDate;
      this.directionId = this.global.eBookingReportSearchCriteria[0].directionId;
      this.global.eBookingReportSearchCriteria = [];
    }
  }
   storeSearchCriteria() {
    this.global.eBookingReportSearchCriteria = [];
    this.global.eBookingReportSearchCriteria.push({
      transitDate: this.transitDate,

      directionId: this.directionId,
    });

  }

  changeCount(event) {
    const value = (event.target as HTMLSelectElement).value;
    const count = Number(value);
    this.pageSize = count;
    this.loadEBookingReport();
  }
  resetMyEBookingReport() {

    this.directionId = "";

    this.transitDate = "";

    this.loadEBookingReport();

  }

  getPendingTask(requestId) {
    //var appInstanceId = requestId;
    this.myTasksService.getAdminTasksByRequestId(this.currentUser.UserName, requestId).subscribe(
      d => {
        if (d.Success) {
          if (d.Data.Collection.length == 0) {
            window.alert(this.translate.instant('SHARED.REPORTS.EBOOKING_REPORT.ZERO_TASKS_REQUEST_MESSAGE'));
          }
          else if (d.Data.Collection.length == 1) {
            this.router.navigate([d.Data.Collection[0]["Url"]], { state: { data: { requestId, appInstanceId: requestId } } });
          }
          else if (d.Data.Collection.length > 1) {
            window.alert(this.translate.instant('SHARED.REPORTS.EBOOKING_REPORT.MULTI_TASKS_REQUEST_MESSAGE'));
          }
          console.log(d.Data.Collection.length);
        }
      }

    );
  }
  getTransitByParentId(requestId) {

    this.baseRequestSrv.GetByParentRequestId(requestId, Service.TransitRequest).subscribe(
      d => {
        if (d.Success) {
          this.transitRequestId = d.Data["Id"];
          requestId = this.transitRequestId;
          const navigationExtras: NavigationExtras = { state: { data: { requestId } } };
          this.router.navigate(['/transitRequest'], navigationExtras);
        }
      });

  }
  loadSailDirections(): void {
    this.lookupService.getSailDirections().subscribe(
      data => this.sailDirections = data.Data as SailDirection[],
      () => console.log("Something went wrong!!"),
      () => console.log("Completed"),
    );
  }
  getFeesByTransitId(requestId) {
    this.baseRequestSrv.getBaseRequest(requestId).subscribe(
      d => {
        if (d.Success) {
          this.feesRequestId = d.Data["ParentRequestId"];
          requestId = this.feesRequestId;
          const navigationExtras: NavigationExtras = { state: { data: { requestId } } };
          this.router.navigate(['/feesEstimation'], navigationExtras);
        }
      });
  }
  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
    this.itemsMenu[1].TitleAr = "تاريخ الطلب";
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = "Workflow Status";
      this.itemsMenu[2].TitleAr = "حالة مسار العمل";
    }
  }
}
